import Vue from "vue";
import VueAgile from 'vue-agile'
import VueApexCharts from "vue-apexcharts";
import VueCookies from 'vue-cookies'
import Vuelidate from "vuelidate";
import VueMask from "v-mask";
import VueRouter from "vue-router";
import Vue2Dropzone from "vue2-dropzone";
import VueQRCodeComponent from 'vue-qrcode-component'
import VueSocialSharing from 'vue-social-sharing'
import vco from "v-click-outside";
import vSelect from "vue-select";
import money from "v-money";
import Multiselect from "vue-multiselect";
import Switches from "vue-switches";
import Select2 from 'v-select2-component';
import tinymce from "vue-tinymce-editor";
import Scrollspy from "vue2-scrollspy";
import DateRangePicker from 'vue2-daterange-picker'
import VueHtmlToPaper from 'vue-html-to-paper';
import draggable from 'vuedraggable'
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import * as VueGoogleMaps from "vue2-google-maps";
import { Splitpanes, Pane } from "splitpanes";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import store from "@/state/store";
import App from "./App.vue";
import router from "./router/index2.js";
import '@/permission'
import "@/validators";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/vi'

Vue.use(ElementUI, { locale });
import VueJWT from 'vuejs-jwt'
Vue.use(VueJWT)

import number from '@coders-tm/vue-number-format'
Vue.use(number, { precision: 2 })

import "@/design/global-css/global.css"
import "@/design/global-css/style-base.scss"
import "@/design/landing.scss"
import "@/design/custom.scss";
import "@/design/index.scss";
import "@/design/pos.scss";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

import "@/helpers/inputmask.js";
import "@/helpers/filter.js";
import "vue-select/src/scss/vue-select.scss";
import './vue-filter'

const VueScrollTo = require("vue-scrollto")

Vue.component("vSelect", vSelect);
Vue.component("ValidationObserver", ValidationObserver)
Vue.component("ValidationProvider", ValidationProvider)
Vue.component("tinymce", tinymce);
Vue.component("apexchart", VueApexCharts)
Vue.component('Select2', Select2);
Vue.component('Switches', Switches);
Vue.component('Multiselect', Multiselect)
Vue.component('Vue2Dropzone', Vue2Dropzone)
Vue.component('qr-code', VueQRCodeComponent)
Vue.component('Splitpanes', Splitpanes)
Vue.component('Pane', Pane)
Vue.component('DateRangePicker', DateRangePicker)
Vue.component('Draggable', draggable)

Vue.use(vco);
Vue.use(VueCookies)
Vue.use(VueRouter);
Vue.use(VueScrollTo);
Vue.use(Vuelidate);
Vue.use(VueMask);
Vue.use(Scrollspy);
Vue.use(Pane);
Vue.use(Splitpanes);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueSocialSharing);
Vue.use(DateRangePicker);
Vue.use(VueHtmlToPaper);
Vue.use(gsap);
Vue.use(VueAgile)
Vue.use(money, { precision: 0 });
Vue.use(require("vue-shortkey"));
Vue.use(require("vue-chartist"));
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE",
    libraries: "places"
  },
  installComponents: true
});

Vue.mixin({created: function () {this.gsap = gsap;}});
Vue.config.productionTip = false;
Vue.$cookies.config('5d','/',process.env.VUE_APP_CROSS_DOMAIN,true,'lax')

vSelect.props.components.default = () => ({
  OpenIndicator: {
    render: createElement =>
      createElement("b-img", {
        props: {
          src: require(`@assets/images/vector-down.svg`),
          center: true
        }
      })
  }
});

Vue.directive('click-outside', {
  bind: (el, binding, vnode) => {
    el.clickOutsideEvent = (event) => {
      if (!(el == event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
})

gsap.registerPlugin(ScrollTrigger);
gsap.defaults({
   duration: 0.3, ease: "easeIn"
})

import showPopup from "./mixins/components/showPopup";
import hidePopup from "./mixins/components/hidePopup";
import multiplicationThousand from "./mixins/function";
import divisionThousand from "./mixins/function";
import checkNumReplaceComma from "./mixins/function";
import formatMoneyNotUnit from "./mixins/function";
import formatMoney from "./mixins/function";
import formatMoneyVND from "./mixins/function";
import inputOrdersData from "./mixins/function";
import outputOrdersData from "./mixins/function";
import countTaxItem from "./mixins/function";
import countDiscountItem from "./mixins/function";
import timeFormatStatus from "./mixins/function";
import timeFormatDate from "./mixins/function";
import timeFormatTime from "./mixins/function";
import sleep from "./mixins/function";
import allowNumbersOnly from "./mixins/function";
import allowNumbersOnlyAndMoveKey from "./mixins/function";
import getAmountCustomerPay from "./mixins/function";
import getNameLocation from "./mixins/function";
import checkConfigInventory from "./mixins/function";
import formatMoneyNotUnitExt from "./mixins/function";
import mergeLineItemLoHsd from "./mixins/function";
import getDateToday from "./mixins/function";
import convertDateItem from "./mixins/function";
import convertIntDateItem from "./mixins/function";
import getDateToday00Hour from "./mixins/function";
import getNumber from "./mixins/function";
import allowNumbersOnlyFloat from "./mixins/function";
import formatInputQuantityFloat from "./mixins/function";
import getPickerOptions from "./mixins/function";
import formatQuantity from "./mixins/function";

Vue.mixin(showPopup);
Vue.mixin(hidePopup);
Vue.mixin(multiplicationThousand);
Vue.mixin(divisionThousand);
Vue.mixin(checkNumReplaceComma);
Vue.mixin(formatMoneyNotUnit);
Vue.mixin(formatMoney);
Vue.mixin(formatMoneyVND);
Vue.mixin(inputOrdersData);
Vue.mixin(outputOrdersData);
Vue.mixin(countTaxItem);
Vue.mixin(countDiscountItem);
Vue.mixin(timeFormatStatus);
Vue.mixin(timeFormatDate);
Vue.mixin(timeFormatTime);
Vue.mixin(sleep);
Vue.mixin(allowNumbersOnly);
Vue.mixin(allowNumbersOnlyAndMoveKey);
Vue.mixin(getAmountCustomerPay);
Vue.mixin(getNameLocation);
Vue.mixin(checkConfigInventory);
Vue.mixin(formatMoneyNotUnitExt);
Vue.mixin(mergeLineItemLoHsd);
Vue.mixin(getDateToday);
Vue.mixin(convertDateItem);
Vue.mixin(convertIntDateItem);
Vue.mixin(getDateToday00Hour);
Vue.mixin(getNumber);
Vue.mixin(allowNumbersOnlyFloat);
Vue.mixin(formatInputQuantityFloat);
Vue.mixin(getPickerOptions);
Vue.mixin(formatQuantity);

import getParamPos from "./mixins/pos/pos";
import nameWithUpc from "./mixins/pos/pos";
import getStockQuantityVari from "./mixins/pos/pos";
import getStockQuantityVariCount from "./mixins/pos/pos";
import chooseVariation from "./mixins/pos/pos";
import formatInputQuantity from "./mixins/pos/pos";
import customerPay from "./mixins/pos/pos";
import addVarForListCart from "./mixins/pos/pos";
import increase from "./mixins/pos/pos";
import randomMinMax from "./mixins/pos/pos";
import getNumberUnique from "./mixins/pos/pos";
import getProductSeries from "./mixins/pos/pos";
import getAmountCustomerPayPos from "./mixins/pos/pos";
import returnPaymentProcessing from "./mixins/pos/pos";
import getProductBatch from "./mixins/pos/pos";
import getExpiredSale from "./mixins/pos/pos";
import getProductBatchAutoSelectBatch from "./mixins/pos/pos";
import genAutoSelectBatch from "./mixins/pos/pos";
import addShowGenAutoSelectBatch from "./mixins/pos/pos";
import checkLessAutoSelectBatch from "./mixins/pos/pos";
import checkLessSeriSelect from "./mixins/pos/pos";

Vue.mixin(getParamPos);
Vue.mixin(nameWithUpc);
Vue.mixin(getStockQuantityVari);
Vue.mixin(getStockQuantityVariCount);
Vue.mixin(chooseVariation);
Vue.mixin(formatInputQuantity);
Vue.mixin(customerPay);
Vue.mixin(addVarForListCart);
Vue.mixin(increase);
Vue.mixin(randomMinMax);
Vue.mixin(getNumberUnique);
Vue.mixin(getProductSeries);
Vue.mixin(getAmountCustomerPayPos);
Vue.mixin(returnPaymentProcessing);
Vue.mixin(getProductBatch);
Vue.mixin(getExpiredSale);
Vue.mixin(getProductBatchAutoSelectBatch);
Vue.mixin(genAutoSelectBatch);
Vue.mixin(addShowGenAutoSelectBatch);
Vue.mixin(checkLessAutoSelectBatch);
Vue.mixin(checkLessSeriSelect);

import TheLayout from "@/router/layouts/the-layout"
import TitlePage from "@/components/title-page"
import BaseButton from "@/components/base-button";
import BaseCheckbox from "@/components/base-checkbox"
import BaseDropdown from "@/components/base-dropdown"
import BaseInputIcon from "@/components/base-input-icon"
import BaseInputIconBox from "@/components/base-input-icon-box"
import BaseInput from "@/components/base-input"
import BaseSelect from "@/components/base-select"
import BaseSwitcher from "@/components/base-switcher"
import BaseTextarea from "@/components/base-textarea"
import BaseDraggable from "@/components/base-draggable"
import BaseTag from "@/components/base-tag"
import BaseUploadImage from "@/components/base-upload-image"
import BaseSearchSelect from "@/components/search/base-search-select"
import BaseModal from "@/components/base-modal"
import BasePopupSuccess from "@/components/base-popup-success"
import BaseSearchbar from "@/components/base-searchbar"
import Loading from "@/components/Loading"
import LayoutCardNote from "@/components/layout-card-note"
import LayoutCardTitle from "@/components/layout-card-title"
import LayoutCard from "@/components/layout-card"
import LayoutCardDouble from "@/components/layout-card-double"
import LayoutControl from "@/components/layout-control"
import LayoutField from "@/components/layout-field"
import LayoutFieldSet from "@/components/layout-field-set"
import LayoutFieldRight from "@/components/layout-field-right"
import LayoutPopup from "@/components/layout-popup"
import LayoutTable from "@/components/layout-table"
import LayoutTabs from "@/components/layout-tabs"
import IconEditRecord from "@/components/base-edit-record"
import NotPermission from '@/components/not-permission'
import BaseBoxIsFill from '@/components/base-box-is-fill'
import BasePaymentStatus from '@/components/base-payment-status'
import EmptyTable from '@/components/empty-table.vue'


Vue.component('TheLayout', TheLayout)
Vue.component('TitlePage', TitlePage)
Vue.component('NotPermission', NotPermission)
Vue.component('BaseSearchSelect', BaseSearchSelect)
Vue.component('BaseButton', BaseButton)
Vue.component('BaseCheckbox', BaseCheckbox)
Vue.component('BaseDropdown', BaseDropdown)
Vue.component('BaseInputIcon', BaseInputIcon)
Vue.component('BaseInputIconBox', BaseInputIconBox)
Vue.component('BaseInput', BaseInput)
Vue.component('BaseSelect', BaseSelect)
Vue.component('BaseSwitcher', BaseSwitcher)
Vue.component('BaseTextarea', BaseTextarea)
Vue.component('BaseDraggable', BaseDraggable)
Vue.component('BaseTag', BaseTag)
Vue.component('BaseUploadImage', BaseUploadImage)
Vue.component('BaseModal', BaseModal)
Vue.component('BasePopupSuccess', BasePopupSuccess)
Vue.component('BaseSearchbar', BaseSearchbar)
Vue.component('Loading', Loading)
Vue.component('LayoutCardNote', LayoutCardNote)
Vue.component('LayoutCardTitle', LayoutCardTitle)
Vue.component('LayoutCard', LayoutCard)
Vue.component('LayoutCardDouble', LayoutCardDouble)
Vue.component('LayoutControl', LayoutControl)
Vue.component('LayoutField', LayoutField)
Vue.component('LayoutFieldRight', LayoutFieldRight)
Vue.component('LayoutFieldSet', LayoutFieldSet)
Vue.component('LayoutPopup', LayoutPopup)
Vue.component('LayoutTable', LayoutTable)
Vue.component('LayoutTabs', LayoutTabs)
Vue.component('IconEditRecord',IconEditRecord)
Vue.component('BaseBoxIsFill', BaseBoxIsFill)
Vue.component('BasePaymentStatus', BasePaymentStatus)
Vue.component('EmptyTable', EmptyTable)

import CKEditor from 'ckeditor4-vue'
Vue.use( CKEditor )

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
